<template>
    <div class="d-flex flex-column align-center">
        <template v-if="loading">
            <span class="mt-8">Memeriksa Pembayaran</span>
            <v-progress-circular
                indeterminate
                color="primary"
                size="128"
                class="mt-8"
            ></v-progress-circular>
        </template>

        <template v-else-if="error">
            <v-alert type="warning" colored-border border="left">
                Belum terbayar
            </v-alert>
            <v-btn @click="check" text color="primary">
                <v-icon left>mdi-refresh</v-icon>
                coba lagi
            </v-btn>
            <v-btn :to="{ name: 'payment' }" exact text class="mt-4">
                <v-icon left>mdi-cash</v-icon>
                bayar ulang
            </v-btn>
        </template>
    </div>
</template>

<script>
const RETRY_LIMIT = 2
export default {
    data: () => ({
        checkCounter: 0,
        loading: true,
        error: false,
    }),

    methods: {
        async check() {
            this.loading = true
            this.checkCounter = 0
            this.error = false

            while (this.checkCounter < RETRY_LIMIT && ! this.error) {
                let result = await this.$apiv2.get(`enrollment/${this.$store.get('enrollment/selected@enrollmentId')}`)

                if (result.data.is_active) {
                    this.$router.replace({ name: 'dashboard' })
                }

                this.checkCounter++

                await new Promise(resolve => setTimeout(() => resolve(), 1000))
            }

            if (this.checkCounter >= RETRY_LIMIT) {
                this.error = true
            }

            this.loading = false
        }
    },

    created() {
        if (this.$store.get('enrollment/selected@is_active')) {
            return this.$router.replace({ name: 'dashboard' })
        } else {
            this.check()
        }
    }
}
</script>
